function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M.484,17.7H1.848a3.426,3.426,0,0,0,6.483,0h8.24a3.373,3.373,0,0,0,3.194,2.317,3.516,3.516,0,0,0,3.509-3.476A3.466,3.466,0,0,0,22.7,14.63V10.014a.576.576,0,0,0-.575-.579H20.97a1.693,1.693,0,0,0-.575.106V8.275a.576.576,0,1,0-1.152,0v.58h-1.7L14.837,4.489c-.012-.02-.032-.031-.046-.049a.576.576,0,0,0-.072-.076.527.527,0,0,0-.105-.071.418.418,0,0,0-.078-.035.528.528,0,0,0-.142-.029c-.015,0-.029-.009-.045-.009H7.133A4.625,4.625,0,0,0,2.528,8.853v.139A2.846,2.846,0,0,0-.092,11.91v5.215A.576.576,0,0,0,.484,17.7Zm4.605,1.158a2.318,2.318,0,1,1,2.3-2.317A2.312,2.312,0,0,1,5.089,18.862Zm3.454-2.316h0a3.469,3.469,0,0,0-3.454-3.476,3.4,3.4,0,0,0-1.41.31V10.02c.086,0,.17-.007.259-.007h15.3v3.114a3.468,3.468,0,0,0-2.878,3.418H8.544ZM20.97,10.593h.576v2.959a3.4,3.4,0,0,0-1.152-.425V11.173A.578.578,0,0,1,20.97,10.593ZM19.82,18.862a2.318,2.318,0,1,1,2.3-2.317A2.313,2.313,0,0,1,19.82,18.862ZM7.133,5.379h6.9l2.158,3.476H3.939c-.089,0-.172.01-.259.012V8.853A3.467,3.467,0,0,1,7.133,5.379Zm-4.605,4.77v4.084a3.461,3.461,0,0,0-.893,2.312H1.06V11.91A1.652,1.652,0,0,1,2.528,10.149Z",
  transform: "translate(0.092 -4.22)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M.575,20.021a.579.579,0,0,0,0,1.158H23.333a.576.576,0,0,0,.575-.579.626.626,0,0,0-.63-.579H.575Z",
  transform: "translate(0.092 -2)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.278,22.841H.575A.58.58,0,0,0,.575,24H23.333a.577.577,0,0,0,.575-.579A.626.626,0,0,0,23.278,22.841Z",
  transform: "translate(0.092 -1)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/classic_vehicle.4edf660e.svg";
export { SvgComponent as ReactComponent };